import React from "react";
// import "./SVG.scss";
import SVGProps from "./SVG.types";
import Site from "./Site";
import Title from "./Title";
import Right from "./Right";
import Lock from "./Lock";
import Unlock from "./Unlock";
import Pile from "./Pile";
import Attendance from "./Attendance";
import Profile from "./Profile";
import LeftArrow from "./LeftArrow";
import RightArrow from "./RightArrow";
import Camera from "./Camera";
import NoDataImg from "./NoDataImg";
import StepCompleteImg from "./StepCompleteImg";
import Delete from "./Delete";
import AttendanceMarked from "./AttendanceMarked";
import Close from "./close";
import SearchIcon from "./SearchIcon";
import OptionIcon from "./OptionIcon";
import MorningIcon from "./MorningIcon";
import NightIcon from "./NightIcon";
import TimeIcon from "./TimeIcon";
import LocationIcon from "./LocationIcon";
import ForgotPasswordImage from "./ForgotPasswordImage";
import Welcome from "./Welcome";
import Calendar from "./Calendar";
import At from "./At";
import Phone from "./Phone";
import PileSearch from "./Pilesearch";
import Newpile from "./Newpile";
import LocationBigIcon from "./LocationBigIcon";
import ChangePasswordImg from "./ChangePasswordImg";
import Inventory from "./Inventory";
import Item from "./Item";
import Quantity from "./Quantity";
import Unit from "./Unit";
import Buld from "./Buld";
import Scaffold from "./Scaffold";
import AttendanceDash from "./AttendanceDash";
import Dashboard from "./Dashboard";
import Machine from "./Machine";
import Project from "./Project";
import Report from "./Report";
import Users from "./Users";
import Bell from "./Bell";
import RedLock from "./RedLock";
import RedUnlock from "./RedUnlock";
import Download from "./Download";
import Present from "./Present";
import Absent from "./Absent";
import Complete from "./Complete";
import Delay from "./Delay";
import Wip from "./Wip";
import WipDelay from "./WipDelay";
import ProjectName from "./ProjectName";
import Client from "./Client";
import Start from "./Start";
import ProjectLocation from "./ProjectLocation";
import Estimate from "./Estimate";
import InventoryModuleIcon from "./InventoryModuleIcon";
import InventoryModal from "./InventoryModal";
import DashboardProfile from "./DashboardProfile";
import MasterConfigIcon from "./MasterConfigIcon";
import ItemRequiredByIcon from "./ItemRequiredByIcon";
import RejectionIcon from "./RejectionIcon";
import SearchApi from "./SearchApi";
import CloseSearchApi from "./CloseSearchApi";
import HandOver from "./HandOver";
import ExpandDown from "./ExpandDown";
import ExpandUp from "./ExpandUp";
import HandoverIcon from "./HandoverIcon";
import TotalProjectIcon from "./TotalProjectIcon";
import Engineer from "./Engineer";
import Operator from "./Operator";
import OverallDelay from "./OverallDelay";
import TotalWorkInProgressBig from "./TotalWorkInProgressBig";
import DiscardedBig from "./DiscardedBig";
import CompletedBig from "./CompletedBig";
import DiscardedSmall from "./DiscardedSmall";
import CompletedSmall from "./CompletedSmall";
import WorkInProgressSmall from "./WorkInProgressSmall";
import Employees from "./Employees";
import MachineUsed from "./MachineUsed";
import Pending from "./Pending";
import ShiftTiming from "./ShiftTiming";
import DelayTillDate from "./DelayTillDate";
import MaxNoDelayCauseAgency from "./MaxNoDelayCauseAgency";
import MaxDelayCauseAgency from "./MaxDelayCauseAgency";
import OtherStuff from "./OtherStuff";
import TotalSubCotractor from "./TotalSubCotractor";
import ManPower from "./ManPower";
import TotalEngineer from "./TotalEngineer";
import CompleteTillDate from "./CompletedTillDate";
import MorningBig from "./MorningBig";
import PileLength from "./PileLength";
import NoDataScreen from "./NoDataScreen";
import Bills from "./Bills";
import FuelCan from "./FuelCan";
import FuelCanDashed from "./FuelCanDashed";
import QuantityReceived from "./QuantityReceived";
import NoDataBig from "./noDataBig";
import SelectOptMsg from "./SelectOptMsg";
import GlobalRank from "./GlobalRank";
import ProjectRank from "./ProjectRank";
import Efficiency from "./Efficiency";
import WorkInProject from "./WorkInProject";
import Approved from "./Approved";
import SubContractor from "./SubContractor";
import RentalMachine from "./RentalMachine";
import RepairMachinery from "./RepairMachinery";
import Miscellaneous from "./Miscellaneous";
import Cash from "./Cash";
import Received from "./Received";
import Consumed from "./Consumed";
import InStock from "./InStock";
import Maintenance from "./Maintenance";
import Error404 from "./Error404";
import Error500 from "./Error500";
import Clock from "./Clock";
import NoDataSmall from "./noDataSmall";

const SVG = ({ type, isActive }: SVGProps) => {
  switch (type) {
    case "site":
      return <Site />;
    case "title":
      return <Title />;
    case "lock":
      return <Lock />;
    case "unlock":
      return <Unlock />;
    case "right":
      return <Right />;
    case "pile":
      return <Pile isActive={isActive} />;
    case "attendance":
      return <Attendance isActive={isActive} />;
    case "profile":
      return <Profile isActive={isActive} />;
    case "leftArrow":
      return <LeftArrow isActive={isActive} />;
    case "rightArrow":
      return <RightArrow isActive={isActive} />;
    case "camera":
      return <Camera />;
    case "noDataImg":
      return <NoDataImg />;
    case "stepCompleteImg":
      return <StepCompleteImg />;
    case "delete":
      return <Delete />;
    case "attendanceMarked":
      return <AttendanceMarked />;
    case "close":
      return <Close />;
    case "searchIcon":
      return <SearchIcon isActive={isActive} />;
    case "optionIcon":
      return <OptionIcon />;
    case "morning":
      return <MorningIcon />;
    case "time":
      return <TimeIcon />;
    case "night":
      return <NightIcon />;
    case "location":
      return <LocationIcon />;
    case "forgotPasswordImage":
      return <ForgotPasswordImage />;
    case "welcome":
      return <Welcome />;
    case "calendar":
      return <Calendar />;
    case "at":
      return <At />;
    case "inventory":
      return <Inventory isActive={isActive} />;
    case "phone":
      return <Phone />;
    case "pilesearch":
      return <PileSearch />;
    case "newpile":
      return <Newpile />;
    case "item":
      return <Item />;
    case "unit":
      return <Unit />;
    case "quantity":
      return <Quantity />;
    case "locationBigIcon":
      return <LocationBigIcon />;
    case "changePasswordImg":
      return <ChangePasswordImg />;
    case "bulb":
      return <Buld />;
    case "scaffold":
      return <Scaffold />;
    case "attendanceDash":
      return <AttendanceDash isActive={isActive} />;
    case "dashboard":
      return <Dashboard isActive={isActive} />;
    case "machine":
      return <Machine isActive={isActive} />;
    case "project":
      return <Project isActive={isActive} />;
    case "report":
      return <Report isActive={isActive} />;
    case "bell":
      return <Bell />;
    case "users":
      return <Users isActive={isActive} />;
    case "redLock":
      return <RedLock />;
    case "redUnlock":
      return <RedUnlock />;
    case "download":
      return <Download />;
    case "present":
      return <Present />;
    case "absent":
      return <Absent />;
    case "complete":
      return <Complete />;
    case "delay":
      return <Delay />;
    case "wip":
      return <Wip />;
    case "wipDelay":
      return <WipDelay />;
    case "projectName":
      return <ProjectName />;
    case "client":
      return <Client />;
    case "start":
      return <Start />;
    case "projectLocation":
      return <ProjectLocation />;
    case "estimate":
      return <Estimate />;
    case "inventoryModuleIcon":
      return <InventoryModuleIcon isActive={isActive} />;
    case "inventoryModal":
      return <InventoryModal />;
    case "dashboardProfile":
      return <DashboardProfile isActive={isActive} />;
    case "masterConfig":
      return <MasterConfigIcon isActive={isActive} />;
    case "itemRequiredByIcon":
      return <ItemRequiredByIcon />;
    case "rejectionIcon":
      return <RejectionIcon />;
    case "searchApiIcon":
      return <SearchApi />;
    case "closeSearchApiIcon":
      return <CloseSearchApi />;
    case "handoverIcon":
      return <HandOver isActive={isActive} />;
    case "expandDown":
      return <ExpandDown />;
    case "expandUp":
      return <ExpandUp />;
    case "handoverCardIcon":
      return <HandoverIcon />;
    case "totalProjectIcon":
      return <TotalProjectIcon />;
    case "engineer":
      return <Engineer />;
    case "operator":
      return <Operator />;
    case "overallDelay":
      return <OverallDelay />;
    case "totalWorkInProgressBig":
      return <TotalWorkInProgressBig />;
    case "workInProgressSmall":
      return <WorkInProgressSmall />;
    case "discardedBig":
      return <DiscardedBig />;
    case "completedBig":
      return <CompletedBig />;
    case "completedSmall":
      return <CompletedSmall />;
    case "discardedSmall":
      return <DiscardedSmall />;
    case "employees":
      return <Employees />;
    case "machineUsed":
      return <MachineUsed />;
    case "pending":
      return <Pending />;
    case "shiftTiming":
      return <ShiftTiming />;
    case "delayTillDate":
      return <DelayTillDate />;
    case "maxNoDelayCauseAgency":
      return <MaxNoDelayCauseAgency />;
    case "maxDelayCauseAgency":
      return <MaxDelayCauseAgency />;
    case "otherStuff":
      return <OtherStuff />;
    case "totalSubContractor":
      return <TotalSubCotractor />;
    case "Manpower":
      return <ManPower />;
    case "completeTillDate":
      return <CompleteTillDate />;
    case "totalEngineer":
      return <TotalEngineer />;
    case "morningBig":
      return <MorningBig />;
    case "pileLength":
      return <PileLength />;
    case "noDataScreen":
      return <NoDataScreen />;
    case "bills":
      return <Bills isActive={isActive} />;
    case "fuelCan":
      return <FuelCan />;
    case "fuelCanDashed":
      return <FuelCanDashed />;
    case "quantityReceived":
      return <QuantityReceived />;
    case "noDataBig":
      return <NoDataBig />;
    case "selectOptMsg":
      return <SelectOptMsg />;
    case "globalRank":
      return <GlobalRank />;
    case "projectRank":
      return <ProjectRank />;
    case "workInProject":
      return <WorkInProject />;
    case "efficiency":
      return <Efficiency />;
    case "approved":
      return <Approved />;
    case "subContractor":
      return <SubContractor />;
    case "rentalMachine":
      return <RentalMachine />;
    case "repairMachinery":
      return <RepairMachinery />;
    case "miscellaneous":
      return <Miscellaneous />;
    case "cash":
      return <Cash />;
    case "received":
      return <Received />;
    case "consumed":
      return <Consumed />;
    case "inStock":
      return <InStock />;
    case "maintenance":
      return <Maintenance isActive={isActive} />;
    case "404Error":
      return <Error404 />;
    case "500Error":
      return <Error500 />;
    case "clock":
      return <Clock />;
    case "noDataSmall":
      return <NoDataSmall />;
    default:
      return <Title />;
  }
};

export default SVG;
